module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle reversetitle"
  }, [_vm._v("工作團隊")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.staffs), function(team) {
    return [_c('p', {
      staticClass: "teamMember"
    }, [_c('span', {
      staticClass: "teamName"
    }, [_vm._v(_vm._s(team.name) + " ")]), _c('br'), _vm._v(_vm._s(team.users.map(function (el) { return el.display_name; }).join('、')))])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddd110c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Staff.vue
// module id = 92
// module chunks = 0